import React, { useEffect, useState } from "react";
import Calculator from "../../../components/calculator";
import "./panel_layout.css";
import InstructionPopUp from "../../../components/instructions/instruction_popup";
import { connect } from "react-redux";
import QuestionPanel from "../question_panel";
import StudentDetails from "../student_details";
import menuIcon from "../../../assets/icons/menu.png";
import menu2 from "../../../assets/icons/menu2.png";
import useWindowDimensions from "../../../services/useWindowDimensions";
import Legends from "./legends";
import saveAndNext from "../../../services/saveAndNext";
import Confirm from "../../../components/confirm";
import { submitTestApi } from "../../../services/saveAndNext";
import Subjectwiselegendsmain from "../subjectwiselegendsmailn";
import calculatorIncon from "../../../assets/icons/calculatorIcan.png";
import instructionIcon from "../../../assets/icons/instructionIncon.png";
import Timer from "../Timer";
import MandatoryQuestion from "../../../components/mandatory_question_popup";
import ConfirmOverall from "../../../components/confirm/confirmOverall";
import { useTranslation } from "react-i18next";

const PanelLayout = (props) => {
  const { t, i18n } = useTranslation();
  const [showCalculater, setShowCalculater] = useState(false);
  const [showInstruction, setShowInstruction] = useState(false);
  const [languageSelected, setLanguageSelected] = useState(() => {
    return Number(localStorage.getItem("preferred_language")) || 1;
  });
    const [ques_data, setQues_data] = useState([]);
    const [showSectionConfirm, setShowSectionConfirm] = useState(false);
    const onSubmitSection = () => {
      setShowSectionConfirm(true);
    };
    const [showConfirm, setShowConfirm] = useState(false);

    const onSubmitNormal = () => {
      setShowConfirm(true);
    };
    const [currentSectionTime, setCurrentSectionTime] = useState(0);

  const [groupQues, setgroupQues] = useState([]);
  const [activeQuesData, setactiveQuesData] = useState({});
  const [showDrop, setShowDrop] = useState(true);
  const [drower, setDrower] = useState(true);
  const [show, setShow] = useState(false);
  const [showMadetry, setshowMadetry] = useState(false);
  const { width } = useWindowDimensions();

  let ques_dataloc;
  let seq = [];
// {console.log("langlist",languageSelected)}
  const fetchQuestionsBasedOnLanguage = async (questions) => {
    // console.log("Selected language in panel:", languageSelected);
    // console.log("[STEP 3] Fetching for lang id:", languageSelected);
    // console.log("[STEP 3] Available languages:", questions);

    if (questions) {
      let language = questions.find((obj) => obj.id == languageSelected);
      if (language && Object.keys(language).length > 0) {
        ques_dataloc = language.ques_data;
        // console.log("[STEP 3] Found ques_data length:", ques_dataloc.length);

        setQues_data(ques_dataloc);
      }
    } else {
      ques_dataloc = props.state.ques_data;
      setQues_data(ques_dataloc);
    }
  };

  const setup_panel = () => {
    const savedIndex = parseInt(localStorage.getItem("activeQuesInd"));
    const savedSection = localStorage.getItem("selectedSection");
  
    const indexToUse = !isNaN(savedIndex) ? savedIndex : 0;
   
    props.dispatch({ type: "ACTIVE_QUESTION_NUMBER", activeQuesInd: indexToUse });
  
    if (savedSection) {
      props.dispatch({ type: "SET_SELECTED_SECTION", selectedSection: savedSection });
    }
  
    setactiveQuesData(ques_dataloc[indexToUse]);
    saveAndNext(props);
  };
  
  const submitApi = () => {
    submitTestApi(props);
  };
  useEffect(async () => {
    if (
      props.state.ques_data == undefined ||
      props.state.test_settings == undefined ||
      props.state.subjects_data == undefined
    ) {
      window.location.replace("/");
    } else {
      const testLanguages = props.state.test_language;
      if (Array.isArray(testLanguages) && testLanguages.length > 1) {
        fetchQuestionsBasedOnLanguage(testLanguages);
      } else {
        setQues_data(props.state.ques_data);
        ques_dataloc = props.state.ques_data;
      }
      if (ques_dataloc.length === 0) {
        window.location.replace("/noQuestion");
      }
      if (ques_dataloc.length > 0) {
        if (props.state.test_settings.is_grouping_subject == 1) {
          if (props?.state?.test_data?.is_neet_test == 1) {
            let groupQuesloc = props.state.subjects_data;
            groupQuesloc.forEach((obj) => {
              obj.questions = [];
            });
            let subjectIds = props.state.subjects_data.map((obj) => {
              return "" + obj.subject_id + "#" + obj.section_id;
            });
            groupQuesloc.forEach((obj, index) => {
              if (
                subjectIds.indexOf("" + obj.subject_id + "#" + obj.section_id) >
                -1
              ) {
                obj.questions = ques_dataloc.filter(
                  (ob) =>
                    "" + obj.subject_id + "#" + obj.section_id ==
                    "" + ob.subject_id + "#" + ob.section_id
                );
                obj.questions.map((item, index) => {
                  seq.push(item);
                });
                setQues_data(seq);
              }
            });
            setgroupQues(groupQuesloc);
          } else {
            let groupQuesloc = props.state.subjects_data;
            groupQuesloc.forEach((obj) => {
              obj.questions = [];
            });
            let subjectIds = props.state.subjects_data.map((obj) => {
              return obj.subject_id;
            });
            groupQuesloc.forEach((obj, index) => {
              if (subjectIds.indexOf(obj.subject_id) > -1) {
                obj.questions = ques_dataloc.filter(
                  (ob) => ob.subject_id == obj.subject_id
                );
                obj.questions.map((item, index) => {
                  seq.push(item);
                });
                setQues_data(seq);
              }
            });
            setgroupQues(groupQuesloc);
          }
        } else {
          seq = ques_dataloc;
          setQues_data(ques_dataloc);
        }
        if (props.state.attempt_data == null && seq.length > 0) {
          let subnum = 0;
          let answer_json = [];
          let is_bookmarked = [];
          let subjective_answer = [];
          const questionStatus = [];
          const arr = [];
          seq.forEach((item, index) => {
            questionStatus.push({
              ques_id: item.ques_id,
              status_number: index == 0 ? 2 : 1,
            });
            is_bookmarked.push(0);
            arr.push(0);
            if (item.ques_type_id == 2) {
              answer_json.push(`subjective_${subnum}`);
              subjective_answer[subnum] = "-1";
              subnum++;
            } else {
              answer_json.push("-1");
            }
          });
          const globalStatusInit = seq.map((q, index) => ({
            ques_id: q.ques_id,
            status_number: index === 0 ? 2 : 1,
          }));
          
          
          props.dispatch({
            type: "GLOBAL_CHANGES_STATUS",
            questionstatus: globalStatusInit,
          });
          
          props.dispatch({
            type: "SET_BOOKMARKED",
            is_bookmarked: [...is_bookmarked],
          });
          props.dispatch({
            type: "SET_ANSWER",
            answers_json: [...answer_json],
          });
          props.dispatch({
            type: "SUBJECTIVE_ANSWERS",
            subjective_answer: [...subjective_answer],
          });
          props.dispatch({
            type: "CHANGES_STATUS",
            questionstatus: questionStatus,
          });
          props.dispatch({ type: "ATTEMPT_TIME", attempt_time: arr });
        } else {
          // ✅ resume flow → hydrate legends
          // ✅ resume flow → hydrate legends and global status
if (props.state.questionstatus && props.state.questionstatus.length > 0) {
  // Update local question status
  props.dispatch({
    type: "CHANGES_STATUS",
    questionstatus: props.state.questionstatus,
  });

  // Update global question status for Legends
  props.dispatch({
    type: "GLOBAL_CHANGES_STATUS",
    questionstatus: props.state.questionstatus,
  });
}

          
        }
        await setup_panel();
      }
    }
  }, []);

  // Language inheritance useEffect - sync i18n with localStorage language from instructions
  useEffect(() => {
    const savedI18nLanguage = localStorage.getItem('i18nextLng');
    if (savedI18nLanguage && i18n.language !== savedI18nLanguage) {
      i18n.changeLanguage(savedI18nLanguage);
    }
  }, [i18n]);

  useEffect(() => {
    if (ques_data.length > 0 && props.activeQuesInd >= 0) {
      let ques_dataloc = ques_data;
      setactiveQuesData(ques_dataloc[props.activeQuesInd]);
    }
  
    const questionStatusloc = props.state.questionstatus;
  
    if (
      Array.isArray(questionStatusloc) &&
      questionStatusloc.length > 0 &&
      ques_data.length > 0 &&
      props.activeQuesInd >= 0 &&
      props.activeQuesInd < questionStatusloc.length
    ) {
      const currentQuesId = ques_data[props.activeQuesInd]?.ques_id;
const indexInStatus = questionStatusloc.findIndex(q => q.ques_id === currentQuesId);

if (indexInStatus !== -1 && questionStatusloc[indexInStatus].status_number === 1) {
  questionStatusloc[indexInStatus].status_number = 2;
  props.dispatch({
    type: "CHANGES_STATUS",
    questionstatus: [...questionStatusloc],
  });
}

    }
  }, [props.activeQuesInd, ques_data]);
  
  
  useEffect(() => {
    var questionList = props.state.test_language;
    // console.log("[STEP 2] languageSelected changed to", languageSelected);

    if (questionList !== undefined) {
      fetchQuestionsBasedOnLanguage(questionList);
    }
  }, [languageSelected]);

  // console.log("Selected language in panel:", languageSelected);

  const changeLanguage = (e) => {
    const selectedValue = parseInt(e.target.value);

    // This function should only handle question language changes
    // The selectedValue is the API language ID (1, 2, 3, etc.)
    setLanguageSelected(selectedValue);
    localStorage.setItem("preferred_language", selectedValue);
    props.dispatch({
      type: "CHANGES_LANGUAGE",
      languageSelected: selectedValue,
    });
  };
  
  const onClickDrop = () => {
    setShowDrop(!showDrop);
  };

  const onSubmit = () => {
    if (props?.state?.test_settings?.is_all_mandatory_questions == 1) {
      if (props?.state?.answers_json?.includes("-1")) {
        setshowMadetry(true);
      } else {
        setShow(true);
      }
    } else {
      setShow(true);
    }
  };

  const getOverallQuestionStats = () => {
    const quesData = ques_data || [];  // ✅ use local state, not props.state.ques_data
    const questionStatus = props.state.questionstatus || [];
  
    if (!Array.isArray(quesData) || quesData.length === 0 || !Array.isArray(questionStatus)) {
      return { total: 0, attempted: 0, marked: 0, unattempted: 0 };
    }
  
    let attempted = 0;
    let marked = 0;
    let unattempted = 0;
  
    for (let q of quesData) {
      const status = questionStatus.find((s) => s.ques_id === q.ques_id);
      if (status) {
        if (status.status_number === 4 || status.status_number === 5) {
          attempted++;
        } else if (status.status_number === 3) {
          marked++;
        } else {
          unattempted++;
        }
      } else {
        unattempted++;
      }
    }
  
    return {
      total: quesData.length,
      attempted,
      marked,
      unattempted,
    };
  };
  
  
  
  useEffect(() => {
    // console.log("🔥 useEffect triggered | Section:", props.selectedSection, "activeQuesInd:", props.activeQuesInd, "ques_data len:", ques_data.length);
  
    if (Array.isArray(ques_data) && ques_data.length > 0) {
      let index = props.activeQuesInd;
  
      if (props.activeQuesIndBySection?.[props.selectedSection] != null) {
        index = props.activeQuesIndBySection[props.selectedSection];
      }
  
      if (index == null || index < 0) index = 0;
      if (index >= ques_data.length) index = ques_data.length - 1;
  
      // console.log("👉 Resolved index:", index);
  
      // ✅ Only re-dispatch if section changed (not on every index update)
      if (props.selectedSection && index !== props.activeQuesInd) {
        props.dispatch({
          type: "ACTIVE_QUESTION_NUMBER",
          activeQuesInd: index,
        });
        // console.log("🚨 Dispatch ACTIVE_QUESTION_NUMBER", index, "from <panel>");
      }
  
      setactiveQuesData(ques_data[index]);
    }
  }, [languageSelected, ques_data, props.selectedSection]); 
  // ❌ removed props.activeQuesInd from deps
  
  
  return (
    <>
      {showCalculater && <Calculator setShowCalculater={setShowCalculater} />}
      {showInstruction && (
        <InstructionPopUp setShowInstruction={setShowInstruction} />
      )}
      {show && (
  <ConfirmOverall
    type="test"
    is_test_submit_status={props.state.test_settings.is_test_submit_status}
    setShow={setShow}
    submitApi={submitApi}

    
  />
)}

{showSectionConfirm && (
  <Confirm
    type="section"
    setShow={setShowSectionConfirm}
    sectionKey={props.state.selectedSection}
    currentTime={currentSectionTime} // live timer

  />
)}
{showConfirm && (
  <Confirm
    type="test"
    setShow={setShowConfirm}
    sectionKey={props.state.selectedSection}
    currentTime={currentSectionTime} // live timer

  />
)}
      
      {showMadetry && <MandatoryQuestion setshowMadetry={setshowMadetry} />}
      <div className="maincontainer">
        <div className="headerpanel">
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <div className="logoImg">
              <button className="logobutton">{t('test.onlineTest')}</button>
            </div>
            <div className="stateLine"></div>
            <div className="subjectTypeDiv">
              <span
                className="subjectType"
                title={props?.state.test_data?.test_name}
              >
                {" "}
{t('test.testName')}: {props.state?.test_data?.test_name}
              </span>
            </div>
          </div>
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div>
              <Timer   onTimeUpdate={(timeLeft) => setCurrentSectionTime(timeLeft)}
/>
            </div>
            <button
              className="showcalculator"
              style={{
                display: props.state.test_settings.is_calculator_available
                  ? "flex"
                  : "none",
              }}
              onClick={() => setShowCalculater(!showCalculater)}
            >
              <img
                style={{
                  height: "16px",
                  width: "14px",
                  marginLeft: "10px",
                  marginRight: "8px",
                }}
                src={calculatorIncon}
              />
              <span className="buttontext" style={{ color: "#0097F9" }}>
{showCalculater ? t('test.hideCalculator') : t('test.showCalculator')}
              </span>
            </button>

            <button
              className="showInstruction"
              onClick={() => {
                setShowInstruction(!showInstruction);
              }}
            >
              <img
                style={{
                  height: "16px",
                  width: "14px",
                  marginLeft: "10px",
                  marginRight: "8px",
                }}
                src={instructionIcon}
              />
              <span className="buttontext" style={{ color: "#0097F9" }}>
{t('test.showInstruction')}
              </span>
            </button>
            <button
              className="dropbutton"
              style={{ background: "none", outline: "none" }}
              onClick={() => onClickDrop()}
            >
              {showDrop == true ? (
                <img width="20px" height="20px" src={menuIcon} />
              ) : (
                <img width="20px" height="20px" src={menu2} />
              )}
            </button>
          </div>
        </div>
        <div className="mainbody">
          {/* {console.log("j",typeof activeQuesData === "object",activeQuesData !== null,Object.keys(activeQuesData).length)} */}
      {typeof activeQuesData === "object" &&
  activeQuesData !== null &&
  Object.keys(activeQuesData).length > 0 && (
    <QuestionPanel
      drower={drower}
      showDrop={showDrop}
      testPanelData={props.testPanelData}
      activeQuesData={activeQuesData}
      ques_data={ques_data}
      changeLanguage={changeLanguage}
      languageSelected={languageSelected}
    />
)}


         
          
          <div
            className={
              showDrop == true
                ? drower === true
                  ? "informationfield"
                  : "widthSize"
                : width > 870
                ? drower === true
                  ? "informationfield"
                  : "widthSize"
                : "hideField"
            }
          >
            <div className="drower" onClick={() => setDrower(false)}>
              <div className="right"></div>
            </div>
            {drower === false && (
              <div className="drower" onClick={() => setDrower(true)}>
                <div className="left"></div>
              </div>
            )}
            <div className="studentDetailsblock">
              <div style={{ display: drower === false && "none" }}>
                <StudentDetails />
              </div>
              <div
                className={drower === false ? "dropbutton" : "testcountnumber"}
              >
                {(groupQues.length > 0 || ques_data.length > 0) && (
                  <Subjectwiselegendsmain
                    groupQues={groupQues}
                    ques_data={ques_data}
                  />
                )}
              </div>
              <div className={drower === false ? "dropbutton" : "legendsmain"}>
  <span style={{ fontWeight: "bold" }}>{t('test.legends')}</span>
  {ques_data.length > 0 && props.state.questionstatus?.length > 0 && (
  <Legends stats={getOverallQuestionStats()} />
)}

</div>

            </div>
           {/* Show Submit Section for all but last section */}
{/* ✅ Footer Buttons */}
{props?.test_data?.is_section_submit === 1 ? (
  // Section-wise submit flow
  props.state.selectedSection !==
    `${props.state.subjects_data[props.state.subjects_data.length - 1].subject_id}#${props.state.subjects_data[props.state.subjects_data.length - 1].section_id}`
    ? (
      <button
        className="submitbutton"
        style={{ display: drower === false && "none" }}
        onClick={() => onSubmitSection()}
      >
        {t('test.submitSection')}
      </button>
    ) : (
      <button
        className="submitbutton"
        style={{ display: drower === false && "none" }}
        onClick={() => onSubmit()}
      >
        {t('test.submit')}
      </button>
    )
) : (
  // Normal full test submit
  <button
    className="submitbutton"
    style={{ display: drower === false && "none" }}
    onClick={() => onSubmitNormal()}
  >
    {t('test.submit')}
  </button>
)}

          </div>
        </div>
      </div>
    </>
  );
};
const mapStateToProps = (state) => ({
  state,
  institute_data: state.institute_data,
  test_data: state.test_data,
  student_data: state.student_data,
  questionstatus: state.questionstatus,
  activeQuesInd: state.activeQuesInd,
});
export default connect(mapStateToProps)(PanelLayout);
